/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiPipeline } from './ApiPipeline';
import {
  ApiPipelineFromJSON,
  ApiPipelineFromJSONTyped,
  ApiPipelineToJSON,
  ApiPipelineToJSONTyped,
} from './ApiPipeline';

/**
 *
 * @export
 * @interface ApiListPipelinesResponse
 */
export interface ApiListPipelinesResponse {
  /**
   *
   * @type {Array<ApiPipeline>}
   * @memberof ApiListPipelinesResponse
   */
  pipelines?: Array<ApiPipeline>;
  /**
   * The total number of pipelines for the given query.
   * @type {number}
   * @memberof ApiListPipelinesResponse
   */
  total_size?: number;
  /**
   * The token to list the next page of pipelines.
   * @type {string}
   * @memberof ApiListPipelinesResponse
   */
  next_page_token?: string;
}

/**
 * Check if a given object implements the ApiListPipelinesResponse interface.
 */
export function instanceOfApiListPipelinesResponse(
  value: object,
): value is ApiListPipelinesResponse {
  return true;
}

export function ApiListPipelinesResponseFromJSON(json: any): ApiListPipelinesResponse {
  return ApiListPipelinesResponseFromJSONTyped(json, false);
}

export function ApiListPipelinesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiListPipelinesResponse {
  if (json == null) {
    return json;
  }
  return {
    pipelines:
      json['pipelines'] == null
        ? undefined
        : (json['pipelines'] as Array<any>).map(ApiPipelineFromJSON),
    total_size: json['total_size'] == null ? undefined : json['total_size'],
    next_page_token: json['next_page_token'] == null ? undefined : json['next_page_token'],
  };
}

export function ApiListPipelinesResponseToJSON(json: any): ApiListPipelinesResponse {
  return ApiListPipelinesResponseToJSONTyped(json, false);
}

export function ApiListPipelinesResponseToJSONTyped(
  value?: ApiListPipelinesResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    pipelines:
      value['pipelines'] == null
        ? undefined
        : (value['pipelines'] as Array<any>).map(ApiPipelineToJSON),
    total_size: value['total_size'],
    next_page_token: value['next_page_token'],
  };
}
